import { useParams, Navigate } from 'react-router-dom';
import { mockPatients, mockReport } from '@/data/mock';
import { ReportShell } from '@/components/report/ReportShell';
import { Breadcrumb } from '@/components/ui/Breadcrumb';

// The report is currently hardcoded (Paciente Anónimo). When the API lands,
// fetch by patient/exam id and pass the typed payload to <ReportShell />.
export function Report() {
  const { id } = useParams<{ id: string }>();
  const patient = mockPatients.find((p) => p.id === id);

  if (!patient) {
    return <Navigate to="/patients" replace />;
  }

  return (
    <main>
      <div className="pane-content appear">
        <Breadcrumb
          className="mb-4"
          items={[
            { label: 'Pacientes', href: '/patients' },
            { label: patient.name, href: `/patients/${patient.id}` },
            { label: 'Reporte' },
          ]}
        />
        <ReportShell report={mockReport} />
      </div>
    </main>
  );
}
